import BuildRow from "~/components/build/BuildRow";
import { noop } from "lodash";
import Icon from "~/components/shared/Icon";

const MergeQueueBaseBranch = (props) => {
  return (
    <div
      className="panel panel-default better-branch-panel depth-150 rounded-1.5 mb-4 mb-6 w-full border-none antialiased"
      data-branch={`merge-queue-${props.mergeQueue.baseBranch}`}
    >
      <div className="panel-heading rounded-top-1.5 charcoal-700 flex items-center bg-slate-100">
        <div className="min-w-0 flex-auto">
          <h2 className="m-0 flex items-center text-sm font-normal">
            <Icon
              icon="custom/outline/14x/git-merge-queue"
              className="mr-0.5"
              style={{ height: 15, width: 15 }}
            />
            <a
              className="no-highlight-link better-branch-panel-name hover-color-inherit"
              href={props.mergeQueue.path}
            >
              Merge queue{" "}
              <span className="code border-gray rounded border px-1 py-0.5">
                {props.mergeQueue.baseBranch}
              </span>
            </a>
          </h2>
        </div>
      </div>
      {props.mergeQueue.builds &&
        props.mergeQueue.builds.map((build) => (
          <BuildRow
            key={build.id}
            build={build}
            setBuildData={noop}
            reloadBuild={noop}
            showStepsToggle={false}
          />
        ))}
    </div>
  );
};

export default MergeQueueBaseBranch;
